const t = {
  name: "Exit",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5857 15.75L17.5857 12.75H10V10.75L17.5857 10.75L14.5857 7.74997L15.9999 6.33576L21.4141 11.75L15.9999 17.1642L14.5857 15.75Z" fill="currentColor"/>
<path d="M11 19.75H12V17.75H11C7.68629 17.75 5 15.0637 5 11.75C5 8.43629 7.68629 5.75 11 5.75V3.75C6.58172 3.75 3 7.33172 3 11.75C3 16.1683 6.58172 19.75 11 19.75Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Exit
};
